RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _) {

    'use strict';

    graph.XY = graph.Block.extend({
        margin: {
            top: 10,
            right: 25,
            bottom: 50,
            left: 110
        },

        ui: {
            chart: '.chart'
        },

        template: function () {
            const template = _.template('<div class="chart xy block-chart text-center" />');
            return template();
        },

        renderData: function () {
            const me = this;

            const attrs = _.defaults({
                margin: me.margin,
                width: me.dimensions.fullWidth,
                height: me.dimensions.height,
                target: me.ui.chart[0],
                axisTicks: 4,
                markerSize: 5
            }, me.options);

            const dotGraph = new graph.DotGraph(attrs);
            dotGraph.render();
            dotGraph.onAttachLoaded();
        }
    });

});
